import React from 'react';
import PolicyLayout from '../components/PolicyLayout';
import SEOHead from '../components/SEOHead';
import { getSEOConfig } from '../utils/seoConfig';

const CommunityPoliciesPage: React.FC = () => {
  const seoConfig = getSEOConfig('/community-policies');

  return (
    <>
      <SEOHead
        title={seoConfig.title}
        description={seoConfig.description}
        keywords={seoConfig.keywords}
        ogType={seoConfig.ogType}
      />
      <PolicyLayout title="Community Policies" lastUpdated="October 2025">
        <p>
          GelWel is committed to creating a safe, respectful, and welcoming environment for all users.
          These community policies outline our expectations and guidelines.
        </p>

        <h2>Content & Community Policy</h2>
        <p>
          GelWel encourages open, respectful interactions. Users must:
        </p>
        <ul>
          <li>Treat others respectfully.</li>
          <li>Avoid hate speech, bullying, or harassment.</li>
          <li>Refrain from posting nudity, violence, or illegal content.</li>
        </ul>
        <p>
          Violations may result in content removal or account suspension.
        </p>

        <h2>User Safety Policy</h2>
        <p>
          GelWel employs reporting tools and moderation systems to protect users.
        </p>
        <ul>
          <li>If you experience harassment or safety concerns, report it in-app or email{' '}
            <a href="mailto:paulfortuneltd@gmail.com">paulfortuneltd@gmail.com</a>.</li>
          <li>In emergencies, contact your local authorities.</li>
        </ul>

        <h3>Reporting Mechanism</h3>
        <p>
          Users can report inappropriate content, harassment, or safety concerns directly through the app.
          All reports are reviewed by our moderation team within 24-48 hours.
        </p>

        <h3>Safety Features</h3>
        <ul>
          <li>Block and report users who violate community guidelines</li>
          <li>Control who can message you and view your profile</li>
          <li>Hide your location and personal information from other users</li>
          <li>Review and manage your privacy settings at any time</li>
        </ul>

        <h2>Child Safety Policy</h2>
        <p>
          GelWel is strictly for users 18 years and older.
        </p>
        <ul>
          <li>We do not knowingly collect or process data from minors.</li>
          <li>If we discover underage use, the account will be removed immediately.</li>
          <li>Users found to be misrepresenting their age will be permanently banned.</li>
        </ul>

        <h3>Reporting Underage Users</h3>
        <p>
          If you suspect a user is under 18, please report them immediately. We take child safety extremely
          seriously and will investigate all reports promptly.
        </p>

        <h2>Review & Moderation Policy</h2>
        <p>
          We value user feedback but maintain the right to:
        </p>
        <ul>
          <li>Moderate or remove reviews containing hate speech, false claims, or private data.</li>
          <li>Ensure all displayed content complies with community and app store guidelines.</li>
          <li>Take action against users who repeatedly violate our policies.</li>
        </ul>

        <h3>Content Moderation Process</h3>
        <p>
          Our moderation team uses both automated systems and human review to ensure compliance with our
          community guidelines. Content may be removed if it violates our policies, and users may receive
          warnings or suspensions depending on the severity of the violation.
        </p>

        <h3>Appeals Process</h3>
        <p>
          If you believe your content was removed in error or your account was suspended unfairly, you can
          appeal the decision by contacting{' '}
          <a href="mailto:paulfortuneltd@gmail.com">paulfortuneltd@gmail.com</a> with the subject line
          "Content Appeal" or "Account Appeal."
        </p>

        <h2>Contact</h2>
        <p>
          For community policy questions or to report violations, contact:{' '}
          <a href="mailto:paulfortuneltd@gmail.com">paulfortuneltd@gmail.com</a>
        </p>
      </PolicyLayout>
    </>
  );
};

export default CommunityPoliciesPage;
